import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1384ce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene-config" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "time-text" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "del-text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "我要"),
  /*#__PURE__*/_createElementVNode("span", null, "离开")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_leave_dailog = _resolveComponent("leave-dailog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["time-box", _ctx.timerText.classColor])
      }, [
        _createElementVNode("img", {
          src: _ctx.parseImgUrl('page-officehome', 'work.svg'),
          alt: ""
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.timerText.text), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.timerText.timer), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["time-btn", _ctx.timerText.showDel ? 'time-btn-small' : '']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerWork && _ctx.triggerWork(...args)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.timerText.btnText), 1)
        ], 2)
      ], 2),
      (_ctx.timerText.showDel)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "time-del",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.myLeaving && _ctx.myLeaving(...args)))
          }, [
            _createElementVNode("img", {
              src: _ctx.parseImgUrl('page-officehome', 'goOffWork.svg'),
              alt: ""
            }, null, 8, _hoisted_4),
            _hoisted_5
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isShowLeaveDailog)
      ? (_openBlock(), _createBlock(_component_leave_dailog, {
          key: 0,
          isShowLeaveDailog: _ctx.isShowLeaveDailog,
          onCloseDailog: _ctx.closeLeavDailog
        }, null, 8, ["isShowLeaveDailog", "onCloseDailog"]))
      : _createCommentVNode("", true)
  ], 64))
}